import { EndpointWithoutRequest, Http } from "Application";
import { AppUrls } from "AppUrls";

export class MentorResponse {
    public id: string = "";
    public firstName: string = "";
    public lastName: string = "";
}

export class GETMentorsEndpoint extends EndpointWithoutRequest<MentorResponse> {
    constructor() {
        super();
        this.verb(Http.Get);
        this.path(AppUrls.Server.Mentor.GetAllMentors);
    }

    public async HandleResponseAsync(responses: MentorResponse[]): Promise<MentorResponse[]> {
        return responses;
    }
}
